// special characters are not allowed as property names in JS objects
const getPropertyNameFromMeasurement = (type: 'l' | 'a' | 'b' | 'hex', versionedMeasurementId: string) =>
    `${type}${versionedMeasurementId.replace(/-/g, '')}`;

export { getPropertyNameFromMeasurement };